import fetchService from '@xanadu/ui-shared/utils/fetchService';
import { LOBBY_TYPES } from '../../constants/casino';

import getTerminal from './util';

const OPTIONS = {
  credentials: 'same-origin',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Id-Type': 'String'
  }
};

const terminal = getTerminal();

export const fetchLobbyViews = () => (
  fetchService(`/casino-api/api/v1/views?terminal=${terminal}&include-lobbies=true`, OPTIONS).then(response => response)
);

export const fetchLobbies = (product) => (
  fetchService(`/casino-api/api/v1/views/${LOBBY_TYPES[product]}/lobbies?terminal=${terminal}&include-sections=true&include-games=true`, OPTIONS).then(response => response)
);

export const fetchAZGames = ({ sectionId, lobbyId, product, letters }) => {
  const path = `/casino-api/api/v1/views/${LOBBY_TYPES[product]}/lobbies/${lobbyId}/sections/${sectionId}/games/by-letter?terminal=${terminal}&letters=${encodeURIComponent(letters)}`;

  return (
    fetchService(path, OPTIONS).then(response => (
      response.games || {}
    ))
  );
};

export const getRealModeGame = (gameId) => (
  fetchService(`/casino-api/api/v1/games/${gameId}/launch-url`, OPTIONS).then(response => response)
);

export const getCasinoBanner = () => (
  fetchService('/ui/api/v1/cms/content?contentType=CasinoBanner', OPTIONS)
    .then((response) => {
      if (response.contentlets) {
        return {
          ...response,
          contentlets: response.contentlets.map((banner) => ({
            ...banner,
            ...(banner.image ? { image: `/dA/${banner.image}` } : {}),
            ...(banner.mobileImage ? { mobileImage: `/dA/${banner.mobileImage}` } : {}),
          }), [])
        };
      }

      return response;
    })
);

